'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeUserFullReference(practice, user) {
  this.Lapp_api_GeneralPracticeUserFullReference__f_practice = null;
  this.Lapp_api_GeneralPracticeUserFullReference__f_user = null;
  this.Lapp_api_GeneralPracticeUserFullReference__f_practice = practice;
  this.Lapp_api_GeneralPracticeUserFullReference__f_user = user;
}
export { $c_Lapp_api_GeneralPracticeUserFullReference as $c_Lapp_api_GeneralPracticeUserFullReference };
$c_Lapp_api_GeneralPracticeUserFullReference.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.constructor = $c_Lapp_api_GeneralPracticeUserFullReference;
/** @constructor */
function $h_Lapp_api_GeneralPracticeUserFullReference() {
}
export { $h_Lapp_api_GeneralPracticeUserFullReference as $h_Lapp_api_GeneralPracticeUserFullReference };
$h_Lapp_api_GeneralPracticeUserFullReference.prototype = $c_Lapp_api_GeneralPracticeUserFullReference.prototype;
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1058773494, true);
});
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_GeneralPracticeUserFullReference)) {
    var x = this.Lapp_api_GeneralPracticeUserFullReference__f_practice;
    var x$2 = x$0.Lapp_api_GeneralPracticeUserFullReference__f_practice;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_api_GeneralPracticeUserFullReference__f_user;
      var x$4 = x$0.Lapp_api_GeneralPracticeUserFullReference__f_user;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.productPrefix__T = (function() {
  return "GeneralPracticeUserFullReference";
});
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_GeneralPracticeUserFullReference__f_practice;
  }
  if ((n === 1)) {
    return this.Lapp_api_GeneralPracticeUserFullReference__f_user;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_GeneralPracticeUserFullReference.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "practice";
  }
  if ((n === 1)) {
    return "user";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_GeneralPracticeUserFullReference(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_GeneralPracticeUserFullReference)));
}
export { $isArrayOf_Lapp_api_GeneralPracticeUserFullReference as $isArrayOf_Lapp_api_GeneralPracticeUserFullReference };
var $d_Lapp_api_GeneralPracticeUserFullReference = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeUserFullReference, "app.api.GeneralPracticeUserFullReference", ({
  Lapp_api_GeneralPracticeUserFullReference: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_GeneralPracticeUserFullReference as $d_Lapp_api_GeneralPracticeUserFullReference };
//# sourceMappingURL=app.api.-General-Practice-User-Full-Reference.js.map
